import { ApplicationState } from '../../../../store/types';
import { DatasetDefinition, DocumentSpecificHiddenFields, HiddenFields } from '../../../datasets/store/types';
import { getClientDatasetsRoot } from '../../store/selectors';
import { ClientDatasetView, ClientDatasets, ClientDatasetsOpenFieldSection } from './types';

export const getAllClientDatasets = (state: ApplicationState): ClientDatasets[] => getClientDatasetsRoot(state).allDatasets;

export const getIsFetchingClientDatasets = (state: ApplicationState): boolean => getClientDatasetsRoot(state).fetchingAllDatasets;

export const getClientDatasetsView = (state: ApplicationState): ClientDatasetView => getClientDatasetsRoot(state).datasetView;

export const getSelectedDatasetId = (state: ApplicationState): number | null => getClientDatasetsRoot(state).selectedDataset;

export const getClientDatasetDefinitions = (state: ApplicationState): DatasetDefinition[] => getClientDatasetsRoot(state).datasetDefinitions;

export const getOpenFieldsAndSections = (state: ApplicationState): ClientDatasetsOpenFieldSection[] => getClientDatasetsRoot(state).openFieldsAndSections;

export const getModalDatasetId = (state: ApplicationState): number | null => getClientDatasetsRoot(state).modalDatasetId;

export const getCurrentHiddenFields = (state: ApplicationState): HiddenFields => getClientDatasetsRoot(state).currentHiddenFields;

export const getDocumentSpecificHiddenFields = (state: ApplicationState): DocumentSpecificHiddenFields => getClientDatasetsRoot(state).documentHiddenFields;

export const getIsSaving = (state: ApplicationState): boolean => getClientDatasetsRoot(state).isSaving;

export const getSavedHiddenFields = (state: ApplicationState): HiddenFields => getClientDatasetsRoot(state).savedHiddenFields;

export const getHiddenFieldsUpdated = (state: ApplicationState): boolean => getClientDatasetsRoot(state).hiddenFieldsUpdated;

export const getUnsavedChangesModalOpen = (state: ApplicationState): boolean => getClientDatasetsRoot(state).unsavedChangesModalOpen;
